import { Accordion, Button } from "react-bootstrap";
import { useEffect, useState } from "react"; 
import Select from "react-select";
import { useRef } from "react";
import InputSlider from "../../../Feeds/AddFeeds/Elements/InputSlider";
import { CLOUD_URL } from "../../../../../../actions/api";
import { baseUrl, resturctureCloudPath } from "../../../../../../utils";
import { FontAwesomeIcon } from "../../../../../CommonComponents/AssetsHelper";
import ColorPicker from "../../../../../CommonComponents/ColorPicker";

const DesignBanner = ({ setSubtitleFontVar,socialIconStatus,socialIcons, logImageUpdate, setSubtitleFontStyle,setTitleFontVar,setTitleFontStyle, fonts, bannerPrevius, ugcSetting, themeBanner, banner, customBannerUpdate, onUppyModal }) => {
 
   
      const {bannerChange, background_color, background_color_two, subTitle, title_font_color, subTitle_font_size, title, subTitle_font_color, title_font_size, social_icon_status, facebook_url, twitter_url, instagram_url, social_icon_size, social_icon_color_status, social_icon_color, banner_height, banner_position, subtitle_font_varient, subtitle_link_font,title_link_font, title_font_varient, bannerType,LogoImage,  CustomBannerImage} = banner;
  
       const selectedBanner = bannerType;
      const logoImg = {...LogoImage, newName: !LogoImage.newName?.includes('app/widget-display/media/banner') ? resturctureCloudPath(LogoImage.newName, `${CLOUD_URL}${LogoImage.path}`) : LogoImage.newName};
      
      const subtitleFontStyle = subtitle_link_font;
      const subtitleFontVar = subtitle_font_varient;
      const titleFontStyle = title_link_font;
      const titleFontVar = title_font_varient;
      const selectIconcolor = social_icon_color_status ? social_icon_color_status-1 : 0
  
      const [fontStyleSelect, setFontStyleSelect] = useState([]);

      const socialIconColorSelect = [
        { label: "Default Colors", value: 1 },
        { label: "Choose Colors", value: 2 },
      ]

      const bannerPostitionSelect = [
        { label: "At top with full width", value: 1 },
        { label: "At bottom with full width", value: 2 },
      ];

      const error = {
        fb: false,
        twitter: false,
        insta: false,
      };
      
    const [openPopOver, setOpenPopOver] = useState(false);
    const [subtitleFontSelect, setSubtitleFontSelect] = useState([]);
    const [titleFontSelect, setTitleFontSelect] = useState([]);
    const [subDefaultValue, setSubDefaultValue] = useState(null);
    const [titleDefaultFont, setTitleDefaultFont] = useState(null); 
    const [changes, setChanges] = useState(false);

    const subVar = useRef();
    
    const changeBanner = (id, changes) => {  

      const logo =  logoImg.id==null || logoImg.newName?.includes('logo_bnr') ? baseUrl(`banner/logo_bnr-${id}.svg`) : logoImg.newName ? resturctureCloudPath(logoImg.newName, `${CLOUD_URL}${logoImg.path}`)  : "";
            
        const logoImage = {
            "id": "",
            "path": "uploaded/",
            "newName": logo,
            "extension": "",
            "imgSource": "1",
            "status":  "1" 
        }

        var subTitleData="";
        var titleData="";
        var subTitle_font_colorData=""
        var title_font_colorData = ""
        var social_icon_colorData=""
        var social_icon_color_statusData=""
     
        const title_2 = "#MYExperience to get 10% off";
        const title_3 = "chance to win $500";
        const title_4 = "Share moments that matter @Taggbox";
        const title_5 = "#AIRJORDON";

        const icon_1 = "#000000";
        const icon_2 = "#fbfbfb";
        const icon_3 = "#ffffff";

        const subTitle_font_colorData_1 = "#000000";
        const subTitle_font_colorData_2 = "#ffffff";
        const subTitleBanner_2 = "Share your experience using";
        const subTitleBanner_3 = "Share your review & stand a";
        const subTitleBanner_4 = "Together, let's celebrate the joy of gifting";
        const subTitleBanner_5 = "Share Your Joy";
        const pBanner =  bannerPrevius?.bannerType


        if(id == 2){  
           subTitleData= subTitle  &&  (String(subTitle)!=subTitleBanner_3 && String(subTitle)!=subTitleBanner_4 && String(subTitle)!=subTitleBanner_5  && String(subTitle)!=subTitleBanner_2)  ? subTitle : subTitleBanner_2 
           titleData = title && (String(title)!=title_3 && String(title)!=title_4 && String(title)!=title_5 && String(title)!=title_2)  ? title : title_2 
           subTitle_font_colorData = subTitle_font_color && (subTitle_font_color!=subTitle_font_colorData_2) &&  (subTitle_font_color!=subTitle_font_colorData_1) || pBanner == 2  ? subTitle_font_color : subTitle_font_colorData_1
           title_font_colorData = title_font_color && (title_font_color!=subTitle_font_colorData_2) &&   (title_font_color!=subTitle_font_colorData_1)  || pBanner == 2 ? title_font_color : subTitle_font_colorData_1
           social_icon_colorData = social_icon_color && (social_icon_color!=icon_3) && (social_icon_color!=icon_2)  && (social_icon_color!=icon_1) ? social_icon_color : icon_1
           social_icon_color_statusData = 2;
         }

        if(id == 3){
          subTitleData= subTitle && (String(subTitle)!=subTitleBanner_2 && String(subTitle)!=subTitleBanner_4 && String(subTitle)!=subTitleBanner_5  && String(subTitle)!=subTitleBanner_3) ? subTitle : subTitleBanner_3 
          titleData = title && (String(title)!=title_2 && String(title)!=title_4 && String(title)!=title_5 && String(title)!=title_3)  ? title : title_3 
          subTitle_font_colorData = subTitle_font_color && ((subTitle_font_color)!=subTitle_font_colorData_1) || pBanner == 3 ? subTitle_font_color : subTitle_font_colorData_2 
          title_font_colorData = title_font_color && ((title_font_color)!=subTitle_font_colorData_1) || pBanner == 3  ? title_font_color : subTitle_font_colorData_2 
          social_icon_colorData = social_icon_color && (social_icon_color!=icon_1) && (social_icon_color!=icon_2) || pBanner == 3 ? social_icon_color : icon_3
          social_icon_color_statusData = 2;
        }

        if(id == 4){
           subTitleData= subTitle && (String(subTitle)!=subTitleBanner_2 && String(subTitle)!=subTitleBanner_3 && String(subTitle)!=subTitleBanner_5  && String(subTitle)!=subTitleBanner_4) ? subTitle : subTitleBanner_4 
           titleData = title && (String(title)!=title_3 && String(title)!=title_2 && String(title)!=title_5 && String(title)!=title_4)  ? title : title_4 
           subTitle_font_colorData = subTitle_font_color && (((subTitle_font_color)!=subTitle_font_colorData_1)  && ((subTitle_font_color)!=subTitle_font_colorData_2) || pBanner == 4)  ? subTitle_font_color : subTitle_font_colorData_2
           title_font_colorData = title_font_color && (((title_font_color)!=subTitle_font_colorData_1) && ((title_font_color)!=subTitle_font_colorData_2) || pBanner == 4)  ? title_font_color : subTitle_font_colorData_2 
           social_icon_colorData = social_icon_color && ((social_icon_color!=icon_1) && (social_icon_color!=icon_2) || pBanner == 4)  ? social_icon_color : icon_2
           social_icon_color_statusData = 2;
        }

         if(id == 5){
          subTitleData= subTitle && (String(subTitle)!=subTitleBanner_2 && String(subTitle)!=subTitleBanner_3 && String(subTitle)!=subTitleBanner_4  && String(subTitle)!=subTitleBanner_5) ? subTitle : subTitleBanner_5 
          titleData = title && (String(title)!=title_3 && String(title)!=title_4 && String(title)!=title_2  && String(title)!=title_5)  ? title : title_5 
          subTitle_font_colorData = subTitle_font_color && (((subTitle_font_color)!=subTitle_font_colorData_1) && ((subTitle_font_color)!=subTitle_font_colorData_2) || pBanner == 5)   ? subTitle_font_color : subTitle_font_colorData_2
          title_font_colorData = title_font_color && (((title_font_color)!=subTitle_font_colorData_1) && ((title_font_color)!=subTitle_font_colorData_2)  || pBanner == 5)   ? title_font_color : subTitle_font_colorData_2 
          social_icon_colorData = social_icon_color && ((social_icon_color!=icon_1) && (social_icon_color!=icon_2) && (social_icon_color!=icon_3) || pBanner == 5)  ? social_icon_color : ""
          social_icon_color_statusData = 1;
        }
        

        const background_colorData = bannerChange &&  !["#F5F7F8","#6244bb","#418EF7","#272626"].includes(background_color) ? background_color : id == 2 ? "#F5F7F8" : (id == 3 ? "#6244bb" : id == 4 ? "#418EF7" : (id == 5 ? "#272626" : ''));        
        const background_color_twoData = background_color_two ?  background_color_two : id == 5 ? '#ffffff' : ''

        themeBanner({
          subTitle : bannerChange && subTitle!=subTitleBanner_2 && subTitle!=subTitleBanner_3 && subTitle!=subTitleBanner_4 && subTitle!=subTitleBanner_5 ? subTitle : subTitleData, 
          social_icon_color_status : bannerChange ? social_icon_color_status : social_icon_color_statusData,
          social_icon_color : social_icon_colorData, 
          title : bannerChange && title!=title_2 && title!=title_3 && title!=title_4  && title!=title_5 ? title : titleData, 
          background_color : background_colorData, 
          background_color_two : background_color_twoData,  
          subTitle_font_color : bannerChange && subTitle_font_color!=subTitle_font_colorData_1 && subTitle_font_color!=subTitle_font_colorData_2 ? subTitle_font_color : subTitle_font_colorData,
          bannerType:id, 
          title_font_color : bannerChange  && title_font_color!=subTitle_font_colorData_1 && title_font_color!=subTitle_font_colorData_2 ? title_font_color : title_font_colorData, 
          LogoImage : logoImage, 
          bannerType: id}, changes)
  };
  
  useEffect(() => {

    setTimeout(() => {
      if (fonts && fonts.length) {
        fontStyleSelect.push({
          value: 0,
          label: (<span key="Default" >
            Default
          </span>)
        });
        fonts.map((font) => {
          fontStyleSelect.push({
            label: (
              <span key={font.family} style={{ fontFamily: `${font.family}` }}>
                {font.family}
              </span>
            ),
            value: font.id,
          });
        })
      }
      if (fonts && fonts.length) {
        if (subtitleFontStyle) {
          setSubDefaultValue(
            fontStyleSelect[
            fontStyleSelect.findIndex(
              (i) => String(i.label.key) == String(subtitleFontStyle)
            )
            ]
          );
          onSubtitleFontChange(
            fontStyleSelect[
            fontStyleSelect.findIndex(
              (i) => String(i.label.key) == String(subtitleFontStyle)
            )
            ],
            changes
          );
        } else {
          onSubtitleFontChange(
            {
              value: 99,
              label: (<span key="None" id='fontVar-subtitle'>
                None
              </span>)
            },
            changes
          );
        }

        if (titleFontStyle) {

          setTitleDefaultFont(
            fontStyleSelect[
            fontStyleSelect.findIndex(
              (i) => String(i.label.key) == String(titleFontStyle || "")
            )
            ]
          );
          onTitleFontChange(
            fontStyleSelect[
            fontStyleSelect.findIndex(
              (i) => String(i.label.key) == String(titleFontStyle)
            )
            ],
            changes
          );
        } else {
          onTitleFontChange(
            {
              value: 99,
              label: (<span key="Default" id='fontVar-title'>
                None
              </span>)
            },
            changes
          );
        }
      } else {
        onSubtitleFontChange(
          {
            value: 99,
            label: (<span key="None" id='fontVar-subtitle'>
              None
            </span>)
          },
          changes
        );
        onTitleFontChange(
          {
            value: 99,
            label: (<span key="None" id='fontVar-title'>
              None
            </span>)
          },
          changes
        );
      }
      if(!changes){
        setChanges(true);
      }
    }, 1000)

  }, [bannerType])

  useEffect(() => {
     if(!bannerType){
       changeBanner(2, false);
      }else{
       changeBanner(bannerType, false);
    }
  }, []);


  const onSubtitleFontChange = (e, changes) => {
    setSubtitleFontSelect(null); 
    setSubtitleFontStyle(e?.label?.key);  themeBanner({subtitle_css_font: e?.label?.key, title_link_font:e?.label?.key}, changes)
    var f = fonts.filter((font) => font.id === e?.value)[0];
    if (f && JSON.parse(f.variants) && JSON.parse(f.variants).length) {

      f = JSON.parse(f.variants).map((f, i) => {
        return {
          label: (
            <span key={f} style={{ fontFamily: `${e.label.key}` }} id='fontVar-subtitle' className={`sGFfonte-${f}`}>
              {f}
            </span>
          ), value: i
        };
      });
      setSubtitleFontSelect(f);
      if (document
        .querySelector("#fontVar-subtitle")) {
        document

          .querySelector("#fontVar-subtitle")
          .innerHTML = (f[0].label.key);

        document.getElementById('fontVar-subtitle').style.fontFamily = `${e.label.key}`
        document.getElementById('fontVar-subtitle').className = `sGFfonte-${f[0].label.key}`
      }
    } else {
      setSubtitleFontSelect([{
        value: 99,
        label: (<span key="None" id='fontVar-subtitle'>
          None
        </span>)
      }])
      if (document
        .querySelector("#fontVar-subtitle")) {
        document
          .querySelector("#fontVar-subtitle")
          .innerHTML = 'None';

        document.getElementById('fontVar-subtitle').style.fontFamily = null
        document.getElementById('fontVar-subtitle').className = null
      }

    }
  };

  const onTitleFontChange = (e, changes) => {
    setTitleFontSelect(null);
    setTitleFontStyle(e?.label.key); themeBanner({title_css_font: e?.label?.key,  title_link_font:e?.label?.key}, changes)
    var f = fonts.filter((font) => font.id === e?.value)[0];
    if (f && JSON.parse(f.variants) && JSON.parse(f.variants).length) {

      f = JSON.parse(f.variants).map((f, i) => {
        return {
          label: (
            <span key={f} style={{ fontFamily: `${e?.label.key}` }} id='fontVar-title' className={`sGFfonte-${f}`}>
              {f}
            </span>
          ), value: i
        };
      });
      setTitleFontSelect(f);
      if (document
        .querySelector("#fontVar-title")) {
        document
          .querySelector("#fontVar-title")
          .innerHTML = (f[0].label.key);

        document.getElementById('fontVar-title').style.fontFamily = `${e?.label.key}`
        document.getElementById('fontVar-title').className = `sGFfonte-${f[0].label.key}`
      }
    } else {

      setTitleFontSelect([{
        value: 99,
        label: (<span key="None" id='fontVar-title'>
          None
        </span>)
      }])
      setTitleFontVar('None')
      if (document
        .querySelector("#fontVar-title")) {
        document
          .querySelector("#fontVar-title")
          .innerHTML = 'None';

        document.getElementById('fontVar-title').style.fontFamily = null
        document.getElementById('fontVar-title').className = null
      }
    }
  };


  const getFileName = (fullFilePath) => {
    let fileName = fullFilePath;

      if (fullFilePath && fullFilePath.includes('https:')) {
        let values = fullFilePath.split('/');
        if (values && values.length > 0) {
          fileName = values[values.length - 1];
        }
    }

    
    return fileName;
  }

  const DesignBanners = [2,3,4,5]

  return (
    <>
        <div className="customBannerPanel">
          <div id="customBannerTypePanel">

             { DesignBanners.map((value)=>{ 
              
                  return(<div className={`chooseBanner ${value==selectedBanner ? 'active-banner' : ''}`}>
                    <label className="w-100">
                      <input
                        type="radio"
                        name=""
                        className="bannerType"
                        value="2"
                        onClick={() => changeBanner(value, true)}
                      />
                      <div className="frontBanner">
                        <img src={baseUrl(`banner/bnr-${value}-new.png`)} alt="banner"
                          width={190}
                          height={15}/>
                      </div>
                    </label>
                  </div>)
              })} 
          </div>
        </div>
     
        <div id="customBannerDesignPanel">
          <Accordion>
            <Accordion.Item eventKey="0">
              <Accordion.Header>Banner Background</Accordion.Header>
              <Accordion.Body>
                {/* <div className="card-body"> */}
                <div className="backgroundForm">
                  <div className="">
                    {selectedBanner !== 4 ? (
                      <div className="" id="bannerLogoDiv">
                        <ImageUploadDiv {...{logoImg, logImageUpdate, onUppyModal, getFileName}}  label={'Logo Image'} status='logo' />
                      </div>
                    ) : null}
  
                    <>
                      <div className="banner-bg-color" id="backgroundColor">
                        <div className="form-group color-popup position-relative">
                          <label>Background Color</label>
                           <ColorPicker id='bgColor' defaultColor={background_color} changeColor={(clr) => themeBanner({ background_color: clr })} />
                        </div>
                      </div>

                      {selectedBanner === 5 ? (
                        <div className="banner-color-right" id="backgroundColorTwo">
                          <div className="form-group color-popup position-relative">
                            <label>Background Color (Right) </label>
                            <ColorPicker id='bgColorRight' defaultColor={background_color_two} changeColor={(clr) => themeBanner({ background_color_two: clr })} />
                          </div>
                        </div>
                      ) : null}
                    </>
                    {selectedBanner !== 5 ? <div className="banner-bg-image" id="backgroundImageDiv">
                    <ImageUploadDiv {...{logoImg :CustomBannerImage , logImageUpdate : customBannerUpdate, onUppyModal, getFileName}} status='background' label={"Background Image"} />
                    </div> : null}
                  </div>
                </div>

              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              <Accordion.Header>Content</Accordion.Header>
              <Accordion.Body>
                <div className="backgroundForm">
                    <div className="form-group">
                      <label>Title</label>
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <span className="input-group-text">
                            <i className="far fa-bookmark"> </i>
                          </span>
                        </div>
                        <input
                          className="form-control"
                          placeholder="Share Your Joy"
                          type={"text"}
                          value={title}
                          onChange={(e) => themeBanner({title: e.target.value})}
                        />
                      </div>
                    </div>
                  
                    <div className="form-group color-popup position-relative">
                      <label className="control-label mb-2">Font Color</label>
                        <ColorPicker id='fontColor2' defaultColor={title_font_color} changeColor={(clr) => themeBanner({title_font_color: clr})} />
                    </div>

                    <div className="form-group">
                      <label> Font Style </label>
                      <div className="">
                        <div className="font-style mb-3">
                          {fontStyleSelect && fontStyleSelect.length ? (
                            <Select
                              options={fontStyleSelect}
                              defaultValue={titleDefaultFont ? titleDefaultFont : fontStyleSelect[0]}
                              onChange={(e) => onTitleFontChange(e, true)}
                            />
                          ) : null}
                        </div>
                        {
                          console.log(titleFontVar,'titleFontVartitleFontVartitleFontVar',titleFontSelect)
                        }
                        <div className="titleVar">
                          {titleFontSelect && titleFontSelect.length ? (
                            <Select
                              options={titleFontSelect}
                              defaultValue={
                                titleFontSelect[
                                titleFontSelect.findIndex(
                                  (i) => i.label?.key == titleFontVar
                                ) > 0 ? titleFontSelect.findIndex(
                                  (i) => i.label?.key == titleFontVar
                                ) : 0
                                ]
                              }
                              onChange={(e) => {setTitleFontVar(e.label.key); themeBanner({title_font_varient: e?.label?.key}) }}
                            />
                          ) : null}
                        </div>
                      </div>
                    </div>
                    
                    <div className="form-group">
                      <label>Font Size </label>
                      
                      <input
                        className="form-control"
                        placeholder="16"
                        type={"number"}
                        onInput={(e)=>{e.target.value = e.target.value.replace(/[^0-9]/g, '').replace(/(\..*?)\..*/g, '$1');
                        themeBanner({title_font_size: e.target.value>30 ? 30 : Number(e.target.value)})}}
                        max={30}
                        min={1}
                        value={title_font_size}
                      />
                    </div>

                    <div className="form-group">
                      <label>Subtitle</label>
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <span className="input-group-text">
                            <i className="far fa-bookmark"> </i>
                          </span>
                        </div>
                        <input
                          className="form-control"
                          placeholder="#MARVEL"
                          type={"text"}
                          value={subTitle}
                          onChange={(e) => themeBanner({subTitle: e.target.value})}
                        />
                      </div>
                    </div>
                    
                    <div className="form-group color-popup position-relative">
                      <label className="control-label mb-2">Font Color</label>
                        <ColorPicker id='fontColor1' defaultColor={subTitle_font_color} changeColor={(clr) => themeBanner({subTitle_font_color: clr})} />
                    </div>
                    

                    <div className="form-group">
                      <label> Font Style </label>
                      <div className="form-group">
                      {fontStyleSelect && fontStyleSelect.length ? (
                           <Select
                           options={fontStyleSelect}
                           defaultValue={subDefaultValue ? subDefaultValue : fontStyleSelect[0]}
                           onChange={(e) => onSubtitleFontChange(e, true)}
                         />
                          ) : null}
                          </div>
                          {subtitleFontSelect && subtitleFontSelect.length ? (
                            <Select
                              options={subtitleFontSelect}
                              ref={subVar}
                              defaultValue={
                                subtitleFontSelect[
                                subtitleFontSelect.findIndex(
                                  (i) =>
                                    i.label.key == subtitleFontVar
                                ) >= 0 ? subtitleFontSelect.findIndex(
                                  (i) =>
                                    i.label.key == subtitleFontVar
                                ) : 0
                                ]
                              }
                              onChange={(e) => {setSubtitleFontVar(e.label.key); themeBanner({subtitle_font_varient: e?.label?.key})}
                              }
                            />
                          ) :
                            null
                          }
                    </div>

                    <div className="form-group">
                      <label>Font Size</label>
                      <input
                        className="form-control"
                        placeholder="16"
                        type={"number"}
                        onInput={(e)=> {e.target.value = e.target.value.replace(/[^0-9]/g, '').replace(/(\..*?)\..*/g, '$1');
                        themeBanner({subTitle_font_size: e.target.value>40 ? 40 : Number(e.target.value)}) } }
                        max={40}
                        min={1}
                        value={subTitle_font_size}
                      />
                    </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2">
              <Accordion.Header>
                <span
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  Social Icons
                  {social_icon_status == "1" &&
                    ((error.fb && socialIcons.fb) ||
                      (error.insta && socialIcons.insta) ||
                      (error.twitter && socialIcons.twitter)) ? (
                    <span
                      className="errorMessage required" 
                      style={{ width: "max-content", marginLeft: "20px" }}
                    >
                      Please enter social profile link(s)
                    </span>
                  ) : null}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <div className="backgroundForm">
                  <div className="form-group">
                    <div className="position-relative" onMouseEnter={() => { setOpenPopOver(true)}} onMouseLeave={() => setOpenPopOver(false)}>
                      <label>Social Icon</label>
                      <div
                        className="form-control"
                        style={{ position: "relative" }}
                      >
                        {social_icon_status == "1" ? "ON" : "OFF"}
                      </div>  
                      {openPopOver ? (
                        <>
                          <div className="chooseBox chooseBoxPopover w-100">
                            <div className="mt-2 mb-2">
                              <div className="radio-inline">
                                <label
                                  className="radio radio-outline radio-primary d-flex align-items-center"
                                  htmlFor="IconOffCheck"
                                >
                                  <input
                                    type="radio"
                                    value="0"
                                    name="data[CustomBanner][socialcheckOnOff]"
                                    id="IconOffCheck"
                                    onChange={(e) =>
                                      themeBanner({social_icon_status:e.target.value})
                                    }
                                    checked={social_icon_status == "0"}
                                  />{" "}
                                  <span></span>
                                  <div>OFF</div>
                                </label>
                              </div>
                            </div>
                            <div className="mt-2 mb-2">
                              <div className="radio-inline">
                                <label
                                  className="radio radio-outline radio-primary d-flex align-items-center"
                                  htmlFor="IconOnCheck"
                                >
                                  <input
                                    type="radio"
                                    value="1"
                                    name="data[CustomBanner][socialcheckOnOff]"
                                    onChange={(e) => 
                                      themeBanner({social_icon_status:e.target.value})
                                    }
                                    checked={social_icon_status == "1"}
                                    id="IconOnCheck"
                                    defaultChecked={true}
                                  />{" "}
                                  <span></span>
                                  <div>ON</div>
                                </label>
                              </div>
                              
                            </div>
                          </div>
                        </>
                      ) : null}
                    </div>
                    {social_icon_status == "1" ? <>
                    <div className="mt-2">
                      <label className="form-check p-0">
                        <input className="networkOnOff form-check-input me-2" type="checkbox"
                          value={socialIcons.fb}
                          checked={socialIcons.fb}
                          onChange={(e) =>{
                            socialIconStatus({...socialIcons,fb: e.target.checked})}
                          }
                        />{" "}
                        Facebook
                      </label>
                    </div> 
                    <div className="mt-2">
                      <label className="form-check p-0">
                        <input
                          className="networkOnOff form-check-input me-2"
                          type="checkbox"
                          value={socialIcons.twitter}
                          checked={socialIcons.twitter}
                          onChange={(e) =>{ 
                              socialIconStatus({...socialIcons,twitter: e.target.checked})
                          }
                          }
                        />
                        Twitter
                      </label>
                    </div>
                    <div className="mt-2">
                      <label className="form-check p-0">
                        <input
                          className="networkOnOff form-check-input me-2"
                          type="checkbox"
                          value={socialIcons.insta}
                          checked={socialIcons.insta}
                          onChange={(e) =>{
                            socialIconStatus({...socialIcons,insta: e.target.checked})}
                          }
                        />{" "}
                        <span className="me-2"></span>
                        Instagram
                      </label>
                    </div></> : null }

                    {social_icon_status == "1" ? (
                     
                       <>
                        <div className="chooseCustomIconCss mt-3">
                          <div className="row">
                            <div className="col-12 facebook_url">
                              <div className="form-group">
                                <label>Facebook Url</label>
                                <input
                                  className="form-control"
                                  placeholder=""
                                  type={"text"}
                                  value={facebook_url}
                                  onChange={(e) => themeBanner({facebook_url:e.target.value})}
                                />
                                {error.fb && socialIcons.fb ? (
                                  <span
                                    className="errorMessage required"
                                  >
                                    Facebook url is required
                                  </span>
                                ) : null}
                              </div>
                            </div>
                            <div className="col-12 twitter_url">
                              <div className="form-group">
                                <label>Twitter Url</label>
                                <input
                                  className="form-control"
                                  placeholder=""
                                  type={"text"}
                                  onChange={(e) =>
                                    themeBanner({twitter_url:e.target.value})
                                  }
                                  value={twitter_url}
                                />
                                {error.twitter && socialIcons.twitter ? (
                                  <span
                                    className="errorMessage required"
                                  >
                                    Twitter url is required
                                  </span>
                                ) : null}
                              </div>
                            </div>
                            <div className="col-12 instagram_url">
                              <div className="form-group">
                                <label>Instagram Url</label>
                                <input
                                  className="form-control"
                                  placeholder=""
                                  type={"text"}
                                  onChange={(e) => themeBanner({instagram_url:e.target.value})}
                                  value={instagram_url}
                                />
                                {error.insta && socialIcons.insta ? (
                                  <span
                                    className="errorMessage required"
                                  >
                                    Instagram url is required
                                  </span>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </div>
                      

                         <div className="">
                          <div className="chooseCustomIconCss">
                            <div className="form-group">
                                <label>Icon Size</label>
                                <input
                                   className="form-control"
                                   placeholder="24"
                                   max={30}
                                   min={15}
                                   type={"number"}
                                   onInput={(e)=>{e.target.value = e.target.value.replace(/[^0-9]/g, '').replace(/(\..*?)\..*/g, '$1');
                                   themeBanner({social_icon_size: e.target.value>30 ? 30 : e.target.value+'px'})
                                  }}
                                   value={String(social_icon_size)>30 ? 30 : String(social_icon_size)?.replace("px", "")}
                                />
                            </div>
                            <div className="form-group">
                                <label>Social Icon Colors  </label>
                                <div className="select-box ">
                                  <Select
                                    key={bannerType}
                                    defaultValue={ socialIconColorSelect[selectIconcolor] }
                                    options={socialIconColorSelect}
                                    onChange={(e) =>
                                       themeBanner({social_icon_color_status:parseInt(e.value)})
                                    }
                                    hideSelectedOptions={false}
                                  />
                                </div>
                              </div>
                              <div className="form-group" style={ social_icon_color_status == 2 ? {} : { display: "none" }}>
                                <div className="form-group color-popup position-relative">
                                  <label className="control-label mb-2">Icon Color</label>
                                    <ColorPicker id='iconColor' defaultColor={social_icon_color} changeColor={(clr) => themeBanner({social_icon_color: clr})} />
                                </div>
                              </div>
                          </div>
                        </div>
                        </>  
                      ) : null}

                  </div>
                </div>
                {/* </div> */}
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="3">
              <Accordion.Header>Position &amp; Height</Accordion.Header>
              <Accordion.Body>
                {/* <div className="card-body"> */}
                <div className="backgroundForm">
                  <label className="d-flex align-items-center justify-content-between"> Banner Height
                    <span>
                      <span className="data bannerHeight"></span>
                      {banner_height} px
                    </span>
                  </label>
                  <div className="form-group px-3">
                    <InputSlider onChangeHandler={(event) => themeBanner({banner_height: parseInt(event) })} isValue={banner_height} max={250} min={100} /> 
                  </div>

                  <div className="form-group mb-0">
                    <label>Banner Image Position </label>
                    <div className="select-box ">
                      <Select defaultValue={ bannerPostitionSelect[banner_position - 1] } options={bannerPostitionSelect} onChange={(e) => { themeBanner({banner_position:e.value})}} />
                    </div>
 
                    </div>
                 </div>
                {/* </div> */}
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
         </div>
    </>
  );
};
export default DesignBanner;


export const ImageUploadDiv = ({logoImg, onUppyModal, logImageUpdate, getFileName, status, label}) => {   
  return (
    <div className="form-group uppy-uploader">
      <label>{label}</label>
      <div className="input-group imageUploadFile">
        <div className="input-group-prepend"> <span className="input-group-text"> 
        <FontAwesomeIcon type={'solid'} icon={'image'} iconClass={'fs-6'} />
          </span> </div>

        <label className="uploadBanner bannlogoImage form-control text-nowrap text-ellipsis overflow-hidden" htmlhtmlFor="bannerlogoImage" onClick={() => onUppyModal(true, status == 'logo' ? 'logo' : '')} >
          {logoImg && logoImg.newName ? getFileName(logoImg.newName) : 'Click to upload'}
        </label>
        <div className="fileUpload" id="kt_uppy_2">
          <input type="hidden" name="bannerImgBack" id="bannerImgBack" />
          <div className="uppy-dashboard"></div>
          <div className="uppy-progress"></div>
        </div>

        <div className="input-group-append">
          {logoImg && logoImg.newName ?
            <Button variant="secondary" className="py-0 removeLogo" onClick={() => logImageUpdate('')} >
              <FontAwesomeIcon type={'regular'} icon={'xmark'} iconClass={'fs-6'} />
            </Button>
            :
            <Button variant="secondary" className="py-0 addLogo" onClick={() => onUppyModal(true, status == 'logo' ? 'logo' : '')} >
              <FontAwesomeIcon type={'regular'} icon={'plus'} iconClass={'fs-6'} />
            </Button>}
        </div>
      </div>
    </div>
  )
}